export { default as SolidPlantSummary } from "./List";
